module.exports = __webpack_public_path__ + "static/media/restoration-hardware-small_2x.966a660d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/restoration-hardware-small_2x.png
// module id = 706
// module chunks = 27